import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';

@Injectable()
export class InviteUserService extends BaseHttpService {

    private rootUrl: string = 'invite-user';

    fetch(brandId: string, inviteId: number): Observable<any> {
        return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/${inviteId}`)

            .pipe(catchError(this.handleError.bind(this)));
    }

    send(brandId: string, data: any): Observable<any> {
      const body = JSON.stringify(data);

      return this.http.post(Config.API + '/' + this.rootUrl + '/' + brandId, body, {headers: contentHeaders})

          .pipe(catchError(this.handleError.bind(this)));
    }
}
